import React from 'react';

export const MONTH_NAMES = {
  1: 'January',
  2: 'February',
  3: 'March',
  4: 'April',
  5: 'May',
  6: 'June',
  7: 'July',
  8: 'August',
  9: 'September',
  10: 'October',
  11: 'November',
  12: 'December',
};

export const MONTH_NAMES_SHORT = {
  1: 'Jan',
  2: 'Feb',
  3: 'Mar',
  4: 'Apr',
  5: 'May',
  6: 'Jun',
  7: 'Jul',
  8: 'Aug',
  9: 'Sep',
  10: 'Oct',
  11: 'Nov',
  12: 'Dec',
};

export const ordinalSuffix = (day) => {
  const j = day % 10;
  const k = day % 100;
  if (j === 1 && k !== 11) return 'st';
  if (j === 2 && k !== 12) return 'nd';
  if (j === 3 && k !== 13) return 'rd';
  return 'th';
};

export const parseOrdinalDateParts = (value) => {
  if (!value) return null;
  try {
    const raw = typeof value === 'string' ? value.trim() : value;
    const date =
      typeof raw === 'string' && /^\d{4}-\d{2}-\d{2}/.test(raw)
        ? new Date(`${raw.slice(0, 10)}T12:00:00`)
        : new Date(raw);
    if (Number.isNaN(date.getTime())) return null;
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    const monthName = MONTH_NAMES[month];
    const monthShort = MONTH_NAMES_SHORT[month];
    if (!monthName) return null;
    return { day, suffix: ordinalSuffix(day), monthName, monthShort, year };
  } catch {
    return null;
  }
};

/** Short date: "4 Aug 2026" */
export const formatShortDate = (value) => {
  const p = parseOrdinalDateParts(value);
  if (!p) return '';
  return `${p.day} ${p.monthShort} ${p.year}`;
};

/** Renders e.g. 1 + small st + March 2026 */
export const OrdinalDateInline = ({ value }) => {
  const p = parseOrdinalDateParts(value);
  if (!p) return <>—</>;
  return (
    <>
      {p.day}
      <sup className="sales-targets-ordinal-suffix">{p.suffix}</sup>
      {` ${p.monthName} ${p.year}`}
    </>
  );
};

/**
 * Plain string range for period banner, e.g. "4 Aug 2026 – Present"
 */
export function buildPeriodRangeLabel(currentPeriod) {
  if (!currentPeriod) return '';

  const {
    start_date,
    target_start_date,
    startDate,
    period_start,
    period_end,
  } = currentPeriod;

  const rawStart = period_start || start_date || target_start_date || startDate;
  if (!rawStart) return '';

  const startLabel = formatShortDate(rawStart);
  if (!startLabel) return '';

  if (!period_end) {
    return `${startLabel} – Present`;
  }

  const endLabel = formatShortDate(period_end);
  return endLabel ? `${startLabel} – ${endLabel}` : `${startLabel} – Present`;
}

/** React node: ordinal date range from latest period API payload */
export function buildPeriodRangeNode(currentPeriod) {
  const label = buildPeriodRangeLabel(currentPeriod);
  return label || null;
}
